import { SyntheticEvent } from "react";
import { Box, Grid, Typography } from "@mui/material";
import "../dossier-styles.scss";
import CustomToggleButtonGroup from "../../../UIElements/CustomToggleButtonGroup";
import DownloadBtn from "../../../UIElements/DownloadBtn";
import { DossierHeaderProps } from "./DossierHeader";
import { DossierStatusEnum } from "../../../../types";
import { dateFormat } from "../../../../consts";
import { formatDate } from "../../../../lib";
import DropDown from "../../../UIElements/DropDown";
import { buildInstructorDropDownItems } from "../../utils";

export default function AdminDossierHeaderContent({
    setActiveTab,
    activeTab,
    tabsMenu,
    headerInfo,
    downloadCertificate,
    downloadAllDoc,
    showDownloadCertificateBtn,
    downloadContract,
    onInstructorAssignChange,
}: DossierHeaderProps) {
    const {
        establishmentName,
        instructorReview,
        validatorDecision,
        dossierDetails,
        instructionInfos,
        submittedAt,
        processingStepThreshold,
        assignedUser,
        instructorList,
    } = headerInfo;

    const instructorDropDownItems = instructorList
        ? buildInstructorDropDownItems(instructorList)
        : [];

    const dossierInIstruction =
        dossierDetails?.dossierStatus?.code &&
        ![
            DossierStatusEnum.FINALISE,
            DossierStatusEnum.ATTENTE_DECISION,
        ].includes(dossierDetails?.dossierStatus?.code as any);

    const showAssignBtn =
        dossierDetails?.dossierStatus.code !== DossierStatusEnum.FINALISE &&
        dossierInIstruction;

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                flexWrap: "wrap",
                gap: "1.5rem",
            }}
        >
            <Grid container spacing={1.5}>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "1.5rem",
                        alignSelf: "stretch",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0.5rem",
                            alignSelf: "stretch",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#023",
                                textAlign: "left",
                                textEdge: "cap",
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                                width: "100%",
                            }}
                        >
                            #{headerInfo.dossierId}
                        </Typography>
                        <Typography
                            sx={{
                                color: "#005499",
                                fontFamily: "Roboto",
                                fontSize: "1.75rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            Dossier de qualification pour l'
                            {headerInfo.referencielName}
                        </Typography>{" "}
                        {/* </Box> */}
                        {establishmentName ? (
                            <Typography
                                sx={{
                                    color: "#023",
                                    fontFamily: "Roboto",
                                    fontSize: "1.25rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "normal",
                                }}
                            >
                                {establishmentName}
                            </Typography>
                        ) : null}
                    </Box>

                    {instructionInfos ? (
                        <Box
                            sx={{
                                display: "flex",
                                gap: "1rem",
                                alignItems: "flex-start",
                                alignSelf: "stretch",
                            }}
                        >
                            {!dossierInIstruction ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                        alignSelf: "stretch",
                                        flex: "1 0 0",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Date de soumission adhérent
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>
                                            {submittedAt
                                                ? formatDate(
                                                      submittedAt,
                                                      dateFormat
                                                  )
                                                : null}
                                        </b>
                                    </Typography>
                                </Box>
                            ) : null}

                            {validatorDecision && !dossierInIstruction ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                        alignSelf: "stretch",
                                        flex: "1 0 0",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Date de soumission instructeur
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>
                                            {dossierDetails?.processedAt
                                                ? formatDate(
                                                      dossierDetails?.processedAt,
                                                      dateFormat
                                                  )
                                                : null}
                                        </b>
                                    </Typography>
                                </Box>
                            ) : null}

                            {dossierInIstruction ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Affecté le
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>{instructionInfos.assignedDate}</b>
                                    </Typography>
                                </Box>
                            ) : null}
                            {dossierInIstruction ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Instruction à fournir avant le
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>
                                            {
                                                instructionInfos.instructionDeadline
                                            }
                                        </b>
                                    </Typography>
                                </Box>
                            ) : null}
                            {/* Aller/retour */}

                            {dossierInIstruction ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Aller/retour
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>{`${instructionInfos.processStep}/${processingStepThreshold}`}</b>
                                    </Typography>
                                </Box>
                            ) : null}
                        </Box>
                    ) : null}

                    {showAssignBtn ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                alignSelf: "stretch",
                                "@media (max-width:1024px)": {
                                    width: "100%",
                                },
                            }}
                        >
                            <DropDown
                                items={instructorDropDownItems}
                                defaultValue={assignedUser ?? ""}
                                placeholder="Affecter un instructeur au dossier"
                                inputlabel={
                                    "Affecter un instructeur au dossier"
                                }
                                onChange={async (event) => {
                                    if (event.target.value) {
                                        await onInstructorAssignChange(
                                            event.target.value
                                        );
                                    }
                                }}
                                selectpx={{
                                    border: "2px solid  #E3E6E8",
                                    background: "#FFF",
                                }}
                                root={{
                                    width: "100%",
                                    "@media (max-width:1024px)": {
                                        width: "100%",
                                    },
                                }}
                            />
                        </Box>
                    ) : null}

                    {!dossierInIstruction ? (
                        <>
                            <Box
                                sx={{
                                    display: "flex",
                                    // flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "1rem",
                                    alignSelf: "stretch",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                        alignSelf: "stretch",
                                        flex: "1 0 0",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Avis instructeur
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>{instructorReview}</b>
                                    </Typography>
                                </Box>

                                {validatorDecision ? (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            gap: "0.5rem",
                                            alignSelf: "stretch",
                                            flex: "1 0 0",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#555A5D",

                                                fontFamily: "Roboto",
                                                fontSize: "0.875rem",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "normal",
                                                alignSelf: "stretch",
                                            }}
                                        >
                                            Décision SYNERPA
                                        </Typography>
                                        <Typography
                                            variant="h1"
                                            sx={{
                                                color: "#555A5D",

                                                fontFamily: "Roboto",
                                                fontSize: "1rem",
                                                fontStyle: "normal",
                                                fontWeight: 500,
                                                lineHeight: "normal",
                                                alignSelf: "stretch",
                                            }}
                                        >
                                            <b>{validatorDecision.label}</b>
                                        </Typography>
                                    </Box>
                                ) : null}
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    // flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "1rem",
                                    alignSelf: "stretch",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                        alignSelf: "stretch",
                                        flex: "1 0 0",
                                    }}
                                ></Box>
                            </Box>
                        </>
                    ) : null}
                </Grid>
                <Grid
                    xs={12}
                    item
                    sm={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "1.5rem",
                    }}
                >
                    <Box
                        sx={{
                            display: "inline-flex",
                            justifyContent: "flex-end",
                            alignItems: "end",
                            float: "right",
                            minHeight: "unset",
                            gap: "0.5rem",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "flex-end",
                                alignItems: "end",
                                justifyContent: "space-between",
                                gap: "0.5rem",
                                "@media (max-width:1024px)": {
                                    width: "100%",
                                    flexDirection: "column",
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "flex-end",
                                    alignItems: "end",
                                    justifyContent: "space-between",
                                    marginTop: "1.5rem",
                                    "@media (max-width:1024px)": {
                                        width: "100%",
                                    },
                                }}
                            >
                                <DownloadBtn
                                    label={"documents"}
                                    title={"Télécharger tous les documents"}
                                    customsx={{
                                        margin: 0,
                                        float: "right",
                                        marginLeft: "auto",
                                        height: "1.87rem",
                                        padding: "0.5rem 1rem",
                                        "@media (max-width:1024px)": {
                                            width: "100%",
                                            marginTop: 0,
                                        },
                                    }}
                                    onClick={async () => {
                                        await downloadAllDoc();
                                    }}
                                />
                            </Box>

                            {showDownloadCertificateBtn ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "flex-end",
                                        alignItems: "end",
                                        justifyContent: "space-between",
                                        marginTop: "1.5rem",
                                        "@media (max-width:1024px)": {
                                            width: "100%",
                                        },
                                    }}
                                >
                                    <DownloadBtn
                                        label={"certificat"}
                                        title={"Télécharger le certificat"}
                                        customsx={{
                                            margin: 0,
                                            float: "right",
                                            marginLeft: "auto",
                                            height: "1.87rem",
                                            padding: "0.5rem 1rem",
                                            "@media (max-width:1024px)": {
                                                width: "100%",
                                                marginTop: 0,
                                            },
                                        }}
                                        onClick={async () => {
                                            if (dossierDetails?.id) {
                                                await downloadCertificate(
                                                    dossierDetails.id
                                                );
                                            }
                                        }}
                                    />
                                </Box>
                            ) : null}

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "flex-end",
                                    alignItems: "end",
                                    justifyContent: "space-between",
                                    marginTop: "1.5rem",
                                    "@media (max-width:1024px)": {
                                        width: "100%",
                                    },
                                }}
                            >
                                <DownloadBtn
                                    label={"contrat"}
                                    title="Télécharger le contrat"
                                    customsx={{
                                        margin: 0,
                                        float: "right",
                                        marginLeft: "auto",
                                        padding: "0.5rem 1rem",
                                        height: "1.87rem",
                                        "@media (max-width:1024px)": {
                                            width: "100%",
                                            marginTop: 0,
                                        },
                                    }}
                                    onClick={async () => {
                                        if (dossierDetails?.id) {
                                            if (downloadContract) {
                                                await downloadContract(
                                                    dossierDetails.id
                                                );
                                            }
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            alignSelf: "flex-end",
                            marginTop: "auto",
                            "@media (max-width:1024px)": {
                                flexDirection: "column",
                                width: "100%",
                            },
                        }}
                    >
                        <CustomToggleButtonGroup
                            tabsMenu={tabsMenu}
                            active={activeTab}
                            handleChange={(e: SyntheticEvent, value: string) =>
                                setActiveTab(value)
                            }
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
